import React from 'react'

const Chapter01 = () => {
  return (
    <div>
      <h3 className='title'>Capítulo 01</h3>
      <div className='description'>Sir Eliot cresceu ouvindo histórias de grandes cavaleiros e aventuras que moldaram sua paixão por justiça e proteção dos mais fracos. Treinado nas artes da cavalaria por seu pai, um respeitado guerreiro, Eliot aprendeu não apenas a manejar a espada com destreza, mas também a entender o verdadeiro significado de ser um cavaleiro: servir ao bem e honrar seus juramentos.</div>

    </div>
  )
}

export default Chapter01